module.exports = __webpack_public_path__ + "static/bg-about-23e5f287eb369ab108a8dfd111746074.jpg";